import React, { useState } from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import {
  ACCEPTED_FILE_TYPES,
  MAX_FILE_SIZE_KB,
} from "../../blockPage.constants";

import "./ImageUploadLegend.scss";

export const ImageUploadLegend = () => {
  const [types] = useState(() => _.keys(ACCEPTED_FILE_TYPES).join(", "));

  return (
    <div
      className="image-upload-legend"
      id="image-upload-legend"
      data-testid="image-upload-info"
    >
      <span className="image-upload-legend__label">
        <FormattedMessage id="file_format" />
      </span>
      <span className="image-upload-legend__value">{types}</span>
      <span className="image-upload-legend__label">
        <FormattedMessage id="max_size" />
      </span>
      <span className="image-upload-legend__value">
        {`${MAX_FILE_SIZE_KB} KB`}
      </span>
    </div>
  );
};
